import { render, staticRenderFns } from "./NeoparentWebcam.vue?vue&type=template&id=1b34c40a&scoped=true"
import script from "./NeoparentWebcam.vue?vue&type=script&lang=js"
export * from "./NeoparentWebcam.vue?vue&type=script&lang=js"
import style0 from "./NeoparentWebcam.vue?vue&type=style&index=0&id=1b34c40a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34c40a",
  null
  
)

export default component.exports